module.exports = __webpack_public_path__ + "static/img/19078D_5_6_V_20230820_fit.c32f811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19078D_5_6_V_20230820_fit.png
// module id = SF1j
// module chunks = 0